import request from '@/utils/request'

export function getBookingOpenDates (data) {
  return request({
    url: '/api/admin/booking-open-dates',
    method: 'post',
    data: data
  })
}
